<script>
import ToggleSwitch from '@/components/ui/buttons/ToggleSwitch.vue'
import { useUserStore } from '@/stores/UserStore'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { goToHealthSystemApp } from '@/utilits/getHealth'
import { usePlatformStore } from '@/stores/PlatformStore'
export default {
  name: 'HealthSyncToggle',
  components: { ToggleSwitch },
  setup () {
    const userStore = useUserStore()
    const platformStore = usePlatformStore()
    const { isHealthAvailable, isHealthAllowed } = storeToRefs(userStore)
    const { platform, isPhone } = storeToRefs(platformStore)
    const toggleValue = ref(isHealthAvailable.value)

    const handleToggle = async () => {
      goToHealthSystemApp()
    }

    return {
      isPhone,
      isHealthAvailable,
      platform,
      toggleValue,
      isHealthAllowed,
      handleToggle
    }
  }
}
</script>

<template>
  <div v-if="isPhone && isHealthAllowed" class="health-sync-wrapper">
    <div class="health-sync">
      <img src="@/assets/uploads/icon/calendar/heart-health.svg" alt="health" />

      <p>Синхронизация со «Здоровье»</p>

      <ToggleSwitch v-model="isHealthAvailable" @click="handleToggle" />
    </div>

    <p v-if="!isHealthAvailable" class="health-sync__warning">
      Предоставьте разрешение на доступ к здоровью.
    </p>
  </div>
</template>

<style scoped lang="scss">
.health-sync-wrapper {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.health-sync {
  display: flex;
  align-items: center;
  img {
    margin-right: 12px;
  }
  > p {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
  }
  label {
    margin-left: auto;
  }
}
.health-sync__warning {
  text-align: left;
}
</style>
